define('AwaLabs.PromoCode', [
    'SC.Configuration'
], function AwaLabsPromoCode(
    Configuration
) {
    'use strict';

    return {
        mountToApp: function mounToApp(application) {
            var layout = application.getComponent('Layout');
            if (layout) {
                layout.addToViewContextDefinition('Cart.Summary.View', 'showPromocodeForm', 'boolean', function fnShowPromoCode(context) {
                    return context && context.showPromocodeForm && Configuration.get('promoCode.active', false);
                })
            }
        }
    }
});
